export const capitalizationClassName = "capitalization-off";

export function withCapitalizationClassName(enabled: boolean): string | undefined {
  return enabled ? capitalizationClassName : undefined;
}
